import Branche from '@/generated/classes/Branche';
export default class BrancheExtend extends Branche {
  constructor() {
    super();
  }
}
